import network from '@common/network/network';

export default {
  fetchMemoryAction(context, {key}) {
    context.commit('setMemoryLoadingState', true);
    return new Promise((resolve, reject) => {
      network.memoryRequests
        .getPublic({key})
        .then(response => {
          context.commit('setMemoryState', response);
          resolve(response);
        })
        .catch(reject)
        .finally(() => {
          context.commit('setMemoryLoadingState', false);
        });
    });
  },
  submitMemoryAction(context, {key, text, audio}) {
    context.commit('setMemorySubmitLoadingState', true);
    return new Promise((resolve, reject) => {
      network.memoryRequests
        .postPublic({key, text, audio})
        .then(response => {
          resolve(response);
        })
        .catch(reject)
        .finally(() => {
          context.commit('setMemorySubmitLoadingState', false);
        });
    });
  },
};
